import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";

import { fetchQuoteRequestsQuotes } from "./fetchQuoteRequestsQuotes.api";

export const quoteRequestsQuotesQuery = (id: string | undefined) => ({
  queryKey: queryKeys.quoteRequests.quotes(id),
  queryFn: () => fetchQuoteRequestsQuotes(id),
  staleTime: STALE_TIME,
  enabled: !!id,
});
